import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import AudioButton from './common/AudioButton';
import music from '../assets/music/music.mp3';

const MusicPlayer = () => {
  const audioEl = useRef(null);
  const [isPlaying, setPlaying] = useState(false);
  const [userInteracted, setUserInteracted] = useState(() => {
    return localStorage.getItem('userInteracted') === 'true';
  });

  const { pathname } = useLocation();

  const playAudio = async () => {
    if (!audioEl.current) return;

    try {
      audioEl.current.muted = false;
      audioEl.current.volume = 0.2;
      await audioEl.current.play();
      setPlaying(true);
    } catch (error) {
      console.warn('Failed to play audio:', error);
      setPlaying(false);
      audioEl.current.muted = true;
    }
  };

  const handleMusicPlay = () => {
    if (!audioEl.current) return;

    if (isPlaying) {
      audioEl.current.pause();
      setPlaying(false);
    } else {
      playAudio();
    }
  };

  const handleUserInteraction = () => {
    if (!userInteracted && audioEl.current) {
      setUserInteracted(true);
      localStorage.setItem('userInteracted', 'true');
      playAudio();
    }
  };

  useEffect(() => {
    if (!audioEl.current) return;

    if (userInteracted) {
      playAudio();
    } else {
      audioEl.current.volume = 0.2;
      audioEl.current.muted = true;
      audioEl.current.play().catch(() => {});
    }

    const handleScroll = () => {
      requestAnimationFrame(handleUserInteraction);
    };

    document.addEventListener('click', handleUserInteraction);
    document.addEventListener('keydown', handleUserInteraction);
    document.addEventListener('touchstart', handleUserInteraction);
    document.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      document.removeEventListener('click', handleUserInteraction);
      document.removeEventListener('keydown', handleUserInteraction);
      document.removeEventListener('touchstart', handleUserInteraction);
      document.removeEventListener('scroll', handleScroll);
    };
  }, [userInteracted]);

  useEffect(() => {
    if (!audioEl.current) return;

    const handlePlay = () => {
      if (userInteracted) {
        audioEl.current.muted = false;
        audioEl.current.volume = 0.2;
      }
    };

    const handlePause = () => {
      setPlaying(false);
    };

    audioEl.current.addEventListener('play', handlePlay);
    audioEl.current.addEventListener('pause', handlePause);

    return () => {
      if (audioEl.current) {
        audioEl.current.removeEventListener('play', handlePlay);
        audioEl.current.removeEventListener('pause', handlePause);
      }
    };
  }, [userInteracted]);

  return (
    <StyledDiv $pathname={pathname}>
      <audio src={music} ref={audioEl} loop></audio>
      <AudioButton onClick={handleMusicPlay} isPlaying={isPlaying} />
    </StyledDiv>
  );
};

const StyledDiv = styled.div`
  position: fixed;
  top: ${({ $pathname }) => ($pathname === '/info' ? '6.6rem' : '1rem')};
  transform: translateX(1.7rem);
  transition: top 0.3s ease;
  z-index: 999;
`;

export default MusicPlayer;
